import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/peer_to_peer_logo.png")